// extracted by mini-css-extract-plugin
export default {"tel__phone":"phone_tel__phone__WEK3G","tel__dropdown":"phone_tel__dropdown__4DNWa","tel__input":"phone_tel__input__sOjaX"};